module.exports = __webpack_public_path__ + "media/play.b0acb4b2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/templates/bouncy/assets/play.svg
// module id = ./src/templates/bouncy/assets/play.svg
// module chunks = 0